var _path, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _polygon2, _polygon3, _rect10, _path3, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#E2804F"
    },
    points: "480.176,407.704 480.176,439.844 488.855,463.539 496.848,463.539 504.407,439.844  504.407,407.704 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.818,
    y: 383.895,
    style: {
      fill: "#F2BF7E"
    },
    width: 39.967,
    height: 24.707
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.803,
    y: 104.128,
    style: {
      fill: "#E2804F"
    },
    width: 23.98,
    height: 39.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.803,
    y: 144.097,
    style: {
      fill: "#D4E4AC"
    },
    width: 23.98,
    height: 239.797
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#F2BF7E"
    },
    points: "132.522,400.329 132.522,503.572 427.502,503.572 427.502,8.428 132.522,8.428  132.522,48.461 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.209,
    y: 64.163,
    style: {
      fill: "#E2804F"
    },
    width: 191.831,
    height: 319.726
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.189,
    y: 88.146,
    style: {
      fill: "#FFFFFF"
    },
    width: 143.876,
    height: 159.868
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.039,391.884H0.215V56.169h207.824V391.884z M16.202,375.899h175.85V72.156H16.202V375.899z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "435.93,512 124.094,512 124.094,400.329 139.897,400.329 139.897,496.198 420.127,496.198 420.127,15.802  139.897,15.802 139.897,48.461 124.094,48.461 124.094,0 435.93,0 "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 331.629,
    y: 40.033,
    style: {
      fill: "#D4E4AC"
    },
    width: 64.263,
    height: 15.802
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.761,
    y: 112.724,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 15.802
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 268.419,
    y: 112.724,
    width: 127.473,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 235.761,
    y: 144.329,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 15.802
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 268.419,
    y: 144.329,
    width: 127.473,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 235.761,
    y: 175.934,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 15.802
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 268.419,
    y: 175.934,
    width: 127.473,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 235.761,
    y: 208.593,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 15.802
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 268.419,
    y: 208.593,
    width: 127.473,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 235.761,
    y: 240.198,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 15.802
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 268.419,
    y: 240.198,
    width: 127.473,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 235.761,
    y: 271.802,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 15.802
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 268.419,
    y: 271.802,
    width: 127.473,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 235.761,
    y: 304.461,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 15.802
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 268.419,
    y: 304.461,
    width: 127.473,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 235.761,
    y: 336.066,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 15.802
  }), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 268.419,
    y: 336.066,
    width: 127.473,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 291.596,
    y: 376.099,
    style: {
      fill: "#D4E4AC"
    },
    width: 24.23,
    height: 15.802
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.629,
    y: 376.099,
    style: {
      fill: "#FFFFFF"
    },
    width: 64.263,
    height: 15.802
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.596,
    y: 400.329,
    style: {
      fill: "#D4E4AC"
    },
    width: 24.23,
    height: 15.802
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 331.629,
    y: 400.329,
    style: {
      fill: "#FFFFFF"
    },
    width: 64.263,
    height: 15.802
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.629,
    y: 423.506,
    style: {
      fill: "#FFFFFF"
    },
    width: 64.263,
    height: 15.802
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 164.123,
    y: 463.539,
    width: 87.44,
    height: 15.802
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M444.358,135.857v80.11h15.802v-64.218l11.655,0.066v240.07h39.967V136.101L444.358,135.857z M495.795,375.899h-7.993 v-223.81h7.993V375.899z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "511.781,128.527 495.979,128.527 495.979,104.296 487.551,104.296 487.551,128.527 471.748,128.527 471.748,88.494  511.781,88.494 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "502.781,471.967 483.405,471.967 471.748,441.294 471.748,423.506 487.551,423.506 487.551,438.393  492.382,451.107 495.979,438.72 495.979,423.506 511.781,423.506 511.781,440.967 "
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 471.744,
    y: 400.329,
    width: 40.033,
    height: 15.802
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.06,256H24.195V80.149H184.06V256z M40.182,240.013h127.891V96.136H40.182V240.013z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 28.226,
    y: 271.802,
    width: 15.802,
    height: 15.802
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 59.831,
    y: 271.802,
    width: 15.802,
    height: 15.802
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 92.485,
    y: 271.802,
    width: 15.802,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 124.09,
    y: 271.802,
    style: {
      fill: "#D4E4AC"
    },
    width: 15.802,
    height: 15.802
  }), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 28.226,
    y: 296.033,
    width: 15.802,
    height: 15.802
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 59.831,
    y: 296.033,
    width: 15.802,
    height: 15.802
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 92.485,
    y: 296.033,
    width: 15.802,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 124.09,
    y: 296.033,
    style: {
      fill: "#D4E4AC"
    },
    width: 15.802,
    height: 15.802
  }), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 28.226,
    y: 320.263,
    width: 15.802,
    height: 15.802
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 59.831,
    y: 320.263,
    width: 15.802,
    height: 15.802
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 92.485,
    y: 320.263,
    width: 15.802,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 124.09,
    y: 320.263,
    style: {
      fill: "#D4E4AC"
    },
    width: 15.802,
    height: 15.802
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.226,
    y: 344.494,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 15.802
  }), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 59.831,
    y: 344.494,
    width: 15.802,
    height: 15.802
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.485,
    y: 344.494,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 15.802
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.09,
    y: 344.494,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 15.802
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.695,
    y: 271.802,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 40.033
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.695,
    y: 320.263,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.802,
    height: 40.033
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 92.485,
    y: 104.296,
    width: 15.802,
    height: 15.802
  })), /*#__PURE__*/React.createElement("rect", {
    x: 115.662,
    y: 104.296,
    style: {
      fill: "#D4E4AC"
    },
    width: 16.856,
    height: 15.802
  }), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 139.892,
    y: 104.296,
    width: 15.802,
    height: 15.802
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancial);
export default __webpack_public_path__ + "static/media/financial.c3cb0868f81e0ad427f4f90dc8f7283f.svg";
export { ForwardRef as ReactComponent };